import { User } from '../../types/user'
import { identifySegmentUser } from './segment.service'

declare global {
  interface Window {
    clarity: any
  }
}

const e2eAccounts = [
  new RegExp('^My Great Company[0-9]+$'),
  new RegExp('^my Company[0-9]+$'),
  new RegExp('Playwright - ')
]

export function identify(user: User): void {
  if (process.env.VUE_APP_ENV !== 'live') return
  const companyName = user.company?.name ?? ''
  if (isE2EAccount(companyName)) return

  identifySegmentUser(user)
  if (window.clarity) window.clarity('set', 'email', user.email)
}

export function isE2EAccount(companyName: string): boolean {
  return e2eAccounts.some(accountName => accountName.test(companyName))
}

export function recordPageInAnalytics(): void {
  if (process.env.VUE_APP_ENV !== 'live' || !window.analytics) return
  const userData = JSON.parse(window.localStorage.getItem('ajs_user_traits') || '{}')
  window.analytics.page(userData)
}
